import axios from "axios";

const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost/api_server"
    : "https://www.ppkm.org.my/api_server";

const submitCorporateApplication = async (payload: any) => {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  try {
    const response = await axios.post(
      `${API_BASE_URL}/submit_corporate_membership_application/`,
      payload,
      config
    );

    return response.data;
  } catch (error) {
    console.log("API request failed:", error);
  }
};

const submitIndividualApplication = async (payload: any) => {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  try {
    const response = await axios.post(
      `${API_BASE_URL}/submit_individual_membership_application/`,
      payload,
      config
    );

    return response.data;
  } catch (error) {
    console.log("API request failed:", error);
  }
};

const api = {
  submitCorporateApplication,
  submitIndividualApplication,
};
export default api;
